import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setCvCapRefillOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getCardioCapRefillOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCardioCapRefillOptions])
    const { entity } = response
    yield put(setCvCapRefillOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCardioCapRefillOptions() error: ${e}`))
  }
}

export function* getCardioCapRefillOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCardioCapRefillOptions)
}
